import { component$, type QRL, type Signal } from "@builder.io/qwik";
import { Modal } from "./ui/modal/modal";
import { Button } from "./ui/button";
import { LuClock } from "@qwikest/icons/lucide";
import { PlanBadge } from "./plan-badge";
import { MembershipPlan } from "~/lib/schemas";
import { Link } from "@builder.io/qwik-city";

export type LifetimeDealModalVariant = "public" | "coach";

export const LifetimeDealModal = component$<{
  isOpen: Signal<boolean>;
  onClose$: QRL<() => void>;
  variant?: LifetimeDealModalVariant;
}>(({ isOpen: show, onClose$, variant = "public" }) => {
  return (
    <Modal.Root bind:show={show}>
      <Modal.Panel>
        <div class="flex flex-col items-center gap-4 text-center">
          <div class="bg-primary/10 rounded-full p-3">
            <LuClock class="text-primary h-6 w-6" />
          </div>
          <h2 class="text-primary font-heading text-2xl font-semibold">
            2024 Lifetime Deal
          </h2>
          <p class="text-secondary">
            Get lifetime access to all features with a one-time payment. Special
            offer available until{" "}
            <span class="font-medium">December 31, 2024</span>.
          </p>
          <div class="flex flex-col items-center gap-3">
            <div class="flex items-center gap-3">
              <PlanBadge membershipPlan={MembershipPlan.Pro} />
              <span class="font-medium">$1,499 one-time</span>
            </div>
            <div class="flex items-center gap-3">
              <PlanBadge membershipPlan={MembershipPlan.ProPlus} />
              <span class="font-medium">$2,999 one-time</span>
            </div>
          </div>
          {variant === "public" ? (
            <>
              <p class="text-tertiary text-sm">
                Create an account or log in to your existing account to upgrade
                to a lifetime plan
              </p>
              <Button onClick$={() => onClose$()}>Got it</Button>
            </>
          ) : (
            <div class="flex gap-3">
              <Button variant="outline" onClick$={() => onClose$()}>
                Maybe later
              </Button>
              <Link href="/coach/membership-plans">
                <Button onClick$={() => onClose$()}>Upgrade now</Button>
              </Link>
            </div>
          )}
        </div>
      </Modal.Panel>
    </Modal.Root>
  );
});
